const BASE_AFF_URL = "https://t.afi-b.com/visit.php?a=o16113a-9524981e&p=l967328c";
const IDS = ["gclid", "gbraid", "wbraid"];

const BASE_AFF_URL2 = "https://px.a8.net/svt/ejp?a8mat=45DWQB+7RTR3M+3EMG+5MG8JL";
const IDS2 = ["gclid", "gbraid", "wbraid"];

const BASE_AFF_URL3 = "https://t.afi-b.com/visit.php?a=D16395s-S526380W&p=b962901c";
const IDS3 = ["gclid", "gbraid", "wbraid"];

export function makeAffiliateUrl() {
  try {
    const origin = typeof window !== "undefined" ? window.location.origin : undefined;
    const u = new URL(BASE_AFF_URL, origin); 
    const src = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");

    IDS.forEach((k) => {
      const v = src.get(k);
      if (v) u.searchParams.set(k, v); 
    });
    return u.toString();
  } catch {
    return BASE_AFF_URL;
  }
}

export function makeAffiliateUrl2() {
  try {
    const origin = typeof window !== "undefined" ? window.location.origin : undefined;
    const u = new URL(BASE_AFF_URL2, origin); 
    const src = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");

    IDS2.forEach((k) => {
      const v = src.get(k);
      if (v) u.searchParams.set(k, v); 
    });
    return u.toString();
  } catch {
    return BASE_AFF_URL2;
  }
}

export function makeAffiliateUrl3() {
  try {
    const origin = typeof window !== "undefined" ? window.location.origin : undefined;
    const u = new URL(BASE_AFF_URL3, origin); 
    const src = new URLSearchParams(typeof window !== "undefined" ? window.location.search : "");

    IDS3.forEach((k) => {
      const v = src.get(k);
      if (v) u.searchParams.set(k, v); 
    });
    return u.toString();
  } catch {
    return BASE_AFF_URL3;
  }
}

export const AFF_BASE_URL = BASE_AFF_URL;

export const AFF_BASE_URL2 = BASE_AFF_URL2;

export const AFF_BASE_URL3 = BASE_AFF_URL3;
